<template>
  <div>
    <el-upload
      v-loading.body="uploading"
      ref="upload"
      :limit="limit"
      :on-preview="handlePictureCardPreview"
      :on-change="onFileChange"
      :before-remove="beforeRemove"
      :on-remove="handleRemove"
      :auto-upload="false"
      :file-list="imageList"
      :on-exceed="handleExceed"
      :http-request="uploadFile"
      element-loading-text="上传中..."
      action=""
      class="upload-demo"
      list-type="picture-card"
      multiple>
      <i class="el-icon-upload"><br><span style="font-size: small">选择图片</span></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img :src="dialogImageUrl" width="100%" alt="">
    </el-dialog>
    <el-button :disabled="uploadDisable" style="margin-left: 10px" size="small" type="success" @click="submitUpload">
      上传到服务器
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'CtmspImagesUpload',
  props: {
    id: {
      type: [String, Number],
      default: undefined
    },
    imageList: {
      type: Array,
      default: () => []
    },
    limit: {
      type: Number,
      required: true
    },
    uploadApi: {
      type: String,
      default: ''
    },
    deleteImageUrl: {
      type: String,
      default: ''
    },
    // 文件类型
    fileType: {
      type: String,
      default: ''
    },
    // 保存的文件夹
    folder: {
      type: String,
      default: ''
    },
    // mq路由键
    routingKey: {
      type: String,
      default: undefined
    },
    // 允许上传的最大值，M为单位
    maxSize: {
      type: Number,
      default: undefined
    }
  },

  data () {
    return {
      uploading: false,
      dialogVisible: false,
      dialogImageUrl: '',
      newChooseImage: [],
      uploadDisable: true
    }
  },
  methods: {
    beforeRemove (file, fileList) {
      return this.$confirm('您确定要删除该图片？')
    },
    handleExceed () {
      this.$message.warning(`当前板块最多允许上传${this.limit}个文件`)
    },
    onFileChange (file, fileList) {
      if (file.status === 'ready') { // 选择文件之后
        if (this.maxSize && file.size / 1024 / 1024 > this.maxSize) {
          const index = fileList.findIndex(item => {
            return item.name === file.name
          })
          console.log(index)
          fileList.splice(index, 1)
          this.fileArr = fileList
          this.$message.warning('上传的文件不要超过' + this.maxSize + 'M。')
          return false
        }
        // jpg|jpeg|png|gif|bmp|ico
        const noPicture = ['picture/jpg', 'picture/jpeg', 'picture/png', 'picture/gif', 'picture/bmp', 'picture/ico'].indexOf(file.type) === -1
        if (this.fileType !== 'picture' || !noPicture) {
          const index = fileList.findIndex(item => {
            return item.name === file.name
          })
          console.log(index)
          fileList.splice(index, 1)
          this.fileArr = fileList
          this.$message.warning(`请选择图片文件`)
          return false
        }
        this.uploadDisable = false
        this.newChooseImage.push(file.name)
        this.$emit('uploaded', false)
      }
    },
    submitUpload () {
      this.formData = new FormData()
      this.$refs.upload.submit()
      this.uploading = true
      if (this.id) {
        this.formData.append('id', this.id)
      }
      if (this.fileType) {
        this.formData.append('fileType', this.fileType)
      }
      // if (this.folder) {
      //     this.formData.append('folder', this.folder)
      // }
      // if (this.routingKey) {
      //     this.formData.append('routingKey', this.routingKey + '.file.upload.' + process.env.ENV_CONFIG)
      // }
      this.$http({
        url: process.env.FILE_BASE_API + this.uploadApi,
        method: 'post',
        data: this.formData
      }).then(res => {
        console.log(res)
        console.log(res.data.rel)
        if (res.data.status === 200) {
          console.log(res.data.data)
          this.uploading = false
          // res.data.split('|').forEach(imagePath => {
          //     this.imageList.push({ name: imagePath, url: process.env.FILE_ROOT_PATH + imagePath })
          // })
          this.imageList.push({ name: res.data.data.http, url: res.data.data.http })
          this.uploadDisable = true
          this.$emit('uploaded', true)
          this.$emit('isEmpty', false)
          const imagePath = this.getImagePath(this.imageList)
          this.$emit('imagePath', imagePath)
          this.newChooseImage = []
          this.$message.success(res.data.data.message)
        } else {
          this.$message.error(res.data.data.message)
        }
      }).catch(() => {
        this.$message.error('上传失败')
        this.uploading = false
      })
    },
    uploadFile (file) {
      this.formData.append('file', file.file)
    },
    handleRemove (file, fileList) {
      if (this.newChooseImage.indexOf(file.name) > -1) {
        this.newChooseImage.splice(this.newChooseImage.indexOf(file.name), 1)
        if (this.newChooseImage.length < 1) {
          this.uploadDisable = true
          this.$emit('uploaded', true)
        }
        return false
      }
      const index = this.imageList.findIndex(image => {
        return image.name === file.name
      })
      this.imageList.splice(index, 1)
      const imagePath = this.getImagePath(this.imageList)
      this.$emit('imagePath', imagePath)
      if (this.imageList.length < 1) {
        this.$emit('isEmpty', true)
      }
      this.$message.success('删除成功')
      // request({
      //     url: process.env.FILE_BASE_API + this.deleteImageUrl,
      //     method: 'delete',
      //     params: { fileName: file.name, id: this.id, fileType: this.fileType, folder: this.folder, routingKey: this.routingKey + '.file.delete.' + process.env.ENV_CONFIG }
      // }).then(() => {
      //     const index = this.imageList.findIndex(image => {
      //         return image.name === file.name
      //     })
      //     this.imageList.splice(index, 1)
      //     const imagePath = this.getImagePath(this.imageList)
      //     this.$emit('imagePath', imagePath)
      //     if (this.imageList.length < 1) {
      //         this.$emit('isEmpty', true)
      //     }
      //     this.$message.success('删除成功')
      // })
    },
    getImagePath (imageList) {
      let imagePath = ''
      imageList.forEach((item) => {
        if (imagePath === '') {
          imagePath = item.name
        } else {
          imagePath = imagePath + '|' + item.name
        }
      })
      return imagePath
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Upload/CtmspImagesUpload.vue